document.addEventListener("DOMContentLoaded", function () {
  function randomInt(start, end = false) {
    if (!end) {
      return Math.floor(Math.random() * start);
    } else {
      return Math.floor(start + Math.random() * (end - start));
    }
  }

  function degToRad(deg) {
    return deg * (Math.PI / 180);
  }

  function mouseAnimation(video, container, offset = 0) {
    let animationEnabled = true;
    if (video) {
      video.addEventListener("play", function () {
        animationEnabled = true;
      });
      video.addEventListener("pause", function () {
        animationEnabled = false;
      });
      if (video.paused) {
        animationEnabled = false;
      }
    }
    const collection = document.querySelector(".custom-cursor-animation.collection-settings");
    if (collection) {
      const obsConfig = { attributes: true, childList: false, subtree: false };
      const obsCb = () => {
        animationEnabled = collection.getAttribute("data-playing") === "true";
      }
      const pauseObs = new MutationObserver(obsCb);
      pauseObs.observe(collection, obsConfig);
    }

    const scale = window.devicePixelRatio;
    const canvasWrapper = container;
    const canvasWrapperRect = canvasWrapper.getBoundingClientRect();

    const canvas = document.createElement("canvas");
    canvas.classList.add("animation-overlay");
    canvas.width = canvasWrapperRect.width * scale;
    canvas.height = canvasWrapperRect.height * scale;
    canvas.style = "width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 10; pointer-events: none;";

    const ctx = canvas.getContext("2d");

    const confettiArray = [];
    let confettiCount = 0;

    class Confetti {
      constructor(x, y) {
        this.x = x + randomInt(40 * scale);
        this.y = y + randomInt(40 * scale) + 5 * scale + offset;
        this.opacity = 1 + Math.random() * 1;
        this.size = Math.floor(3 + Math.random() * 4) * (scale / 2);
        this.angle = degToRad(randomInt(0, 45));
        this.stepX = Math.floor(Math.cos(this.angle) * 2 * scale);
        this.stepY = Math.floor(Math.sin(this.angle) * 2 * scale);
      }

      drawConfetti() {
        ctx.shadowBlur = 6;
        ctx.shadowColor = "#ffeb3b";
        ctx.fillStyle = "#fdffe7";
        ctx.globalAlpha = this.opacity;

        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, 2 * Math.PI);
        ctx.fill();
      }

      update() {
        this.drawConfetti();

        this.x += this.stepX;
        this.y += this.stepY;
        this.opacity -= 0.05;
      }
    }

    const mouse = {
      x: 0,
      y: 0,
    };

    function updateMouse(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - rect.left) * scale;
      const y = (e.clientY - rect.top) * scale;

      if (Math.abs(x - mouse.x) > 12 || Math.abs(y - mouse.y) > 12) {
        mouse.x = x;
        mouse.y = y;

        if (animationEnabled) {
          confettiArray.push(new Confetti(mouse.x, mouse.y));
          confettiCount += 1;
        }
      }
    }

    const fps = 30;
    const fpsInterval = 1000 / fps;
    let lastFrameTime = 0;

    function animate(currentTime) {
      requestAnimationFrame(function (currentTime) {
        animate(currentTime);
      });

      const delta = currentTime - lastFrameTime;

      if (delta > fpsInterval) {
        lastFrameTime = currentTime - (delta % fpsInterval);

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confettiArray.sort(function (a, b) {
          return a.opacity > b.opacity ? -1 : 1;
        });
        for (let i = confettiArray.length - 1; i >= 0; i--) {
          confettiArray[i].update();
          if (confettiArray[i].opacity < 0) {
            confettiArray.pop();
          }
        }

        const canvasRect = canvas.getBoundingClientRect();
        if (canvas.width !== Math.floor(canvasRect.width * scale) || canvas.height !== Math.floor(canvasRect.height * scale)) {
          canvas.width = Math.floor(canvasRect.width * scale);
          canvas.height = Math.floor(canvasRect.height * scale);
        }
      }
    }

    canvasWrapper.appendChild(canvas);
    canvasWrapper.addEventListener("mousemove", updateMouse);

    animate();
  }

  function mouseAnimationWithImageParticles(container, particleImage, particleSize, offset = 0) {
    const scale = window.devicePixelRatio || 1;
    const incrementalSize = parseInt(particleSize, 10) || 100;
    const canvasWrapper = container;
    const canvasWrapperRect = canvasWrapper.getBoundingClientRect();

    const canvas = document.createElement("canvas");
    canvas.width = canvasWrapperRect.width * scale;
    canvas.height = canvasWrapperRect.height * scale;
    canvas.style = "width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 12; pointer-events: none;";
    let isPlaying = true;
    const collection = document.querySelector(".custom-cursor-animation.collection-settings");
    const obsConfig = { attributes: true, childList: false, subtree: false };
    const obsCb = () => {
      isPlaying = collection.getAttribute("data-playing") === "true";
    }
    const pauseObs = new MutationObserver(obsCb);
    pauseObs.observe(collection, obsConfig);

    container.appendChild(canvas);
    const ctx = canvas.getContext("2d");

    const confettiArray = [];
    class ImageConfetti {
      constructor(x, y) {
        this.x = x + randomInt(40 * scale);
        this.y = y + randomInt(40 * scale) + 5 * scale + offset;
        this.opacity = 1 + Math.random() * 1;
        this.size = Math.floor(3 + Math.random() * 4) * (scale / 2) * (incrementalSize / 100);
        this.angle = degToRad(randomInt(0, 45));
        this.stepX = Math.floor(Math.cos(this.angle) * 2 * scale);
        this.stepY = Math.floor(Math.sin(this.angle) * 2 * scale);
      }

      drawConfetti() {
        ctx.globalAlpha = this.opacity;
        ctx.drawImage(particleImage, this.x, this.y, this.size, this.size);
      }

      update() {
        this.drawConfetti();
        
        this.x += this.stepX;
        this.y += this.stepY;
        this.opacity -= 0.05;
      }
    }

    const mouse = {
      x: 0,
      y: 0,
    };

    function updateMouse(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - rect.left) * scale;
      const y = (e.clientY - rect.top) * scale;

      if (Math.abs(x - mouse.x) > 12 || Math.abs(y - mouse.y) > 12) {
        mouse.x = x;
        mouse.y = y;
        if (isPlaying) {
          confettiArray.push(new ImageConfetti(mouse.x, mouse.y));
        }
      }
    }

    const fps = 30;
    const fpsInterval = 1000 / fps;
    let lastFrameTime = 0;

    function animate(currentTime) {
      requestAnimationFrame(function (currentTime) {
        animate(currentTime);
      });

      const delta = currentTime - lastFrameTime;

      if (delta > fpsInterval) {
        lastFrameTime = currentTime - (delta % fpsInterval);

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confettiArray.sort(function (a, b) {
          return a.opacity > b.opacity ? -1 : 1;
        });
        for (let i = confettiArray.length - 1; i >= 0; i--) {
          confettiArray[i].update();
          if (confettiArray[i].opacity < 0) {
            confettiArray.pop();
          }
        }

        const canvasRect = canvas.getBoundingClientRect();
        if (canvas.width !== Math.floor(canvasRect.width * scale) || canvas.height !== Math.floor(canvasRect.height * scale)) {
          canvas.width = Math.floor(canvasRect.width * scale);
          canvas.height = Math.floor(canvasRect.height * scale);
        }
      }
    }

    canvasWrapper.appendChild(canvas);
    canvasWrapper.addEventListener("mousemove", updateMouse);

    animate();
  }

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
  if (window.matchMedia("(hover:hover) and (pointer:fine)").matches && !prefersReducedMotion) {
    const videos = document.querySelectorAll(".custom-cursor-animation video");
    const collection = document.querySelector(".custom-cursor-animation.collection-settings");
    const headers = document.getElementsByClassName("shopify-section-group-header-group")
    const headersArr = [].slice.call(headers);
    const headersHeight = headersArr.reduce((acc, {clientHeight}) => acc + clientHeight, 0);
    for (const video of videos) {
      const container = video.parentElement;
      mouseAnimation(video, container);
    }
    if (collection) {
      const container = collection.closest("#collection-wrapper");
      const particleSize = collection.getAttribute('data-particle-size');
      const particleUrl = collection.getAttribute('data-particle');
      const animationType = collection.getAttribute('data-animation');
      const particleImage = new Image();
      particleImage.src = particleUrl;

      switch (animationType) {
        case "confetti":
          mouseAnimation(null, container, headersHeight);
          break;
        case "image":
          mouseAnimationWithImageParticles(container, particleImage, particleSize, headersHeight);
          break;
        default:
          break;
      }
    }
  }
});
